import TagManager from 'react-gtm-module/dist/TagManager'
import { getEventCategory, getCurrentStore } from '../../utils/analytics/analytics'

export const gtmId = 'GTM-K9LNN8Q'

export const gtmFunctions = {
  GTMUnderstand: () => GTMUnderstand(),
  GTMUnderstandFinish: () => GTMUnderstandFinish(),
  GTMQuests: () => GTMQuests(),
  GTMGifts: () => GTMGifts(),
  GTMGames: () => GTMGames(),
  GTMCustomization: () => GTMCustomization(),
  GTMShopItem: (data) => GTMShopItem(data),
  GTMPrizes: () => GTMPrizes(),
  GTMRoadmap: () => GTMRoadmap(),
  GTMFriends: () => GTMFriends(),
  GTMShop: () => GTMShop(),
  GTMBuyBtn: (number) => GTMBuyBtn(number),
  GTMQuizBackToGame: (number) => GTMQuizBackToGame(number),
  GTMProcedureBuyBtn: (type) => GTMProcedureBuyBtn(type),
  GTMProcedureBackToGame: (type) => GTMProcedureBackToGame(type),
  GTMToProductAfterQuiz: (number, item_sku) => GTMToProductAfterQuiz(number, item_sku),
  GTMToProductAfterProcedure: (type, item_sku) => GTMToProductAfterProcedure(type, item_sku),
  GTMToProductAfterQuest: (name, item_sku) => GTMToProductAfterQuest(name, item_sku),
  GTMToShopAfterQuest: (name) => GTMToShopAfterQuest(name),
  GTMGoToShopAfterPrize: () => GTMGoToShopAfterPrize(),
  GTMHello: () => GTMHello(),
  GTMQuiz: () => GTMQuiz(),
  GTMPalleteTutorial: () => GTMPalleteTutorial(),
  GTMOnClickOnboardingPalette: () => GTMOnClickOnboardingPalette(),
  GTMChallenges: () => GTMChallenges(),
  GTMChallengesTabs: ({ tab }) => GTMChallengesTabs({ tab }),
  GTMBoxes: () => GTMBoxes(),
  GTMBoxesBuy: () => GTMBoxesBuy(),
  GTMAchievements: ({ name }) => GTMAchievements({ name }),
  GTMAchievementsModal: ({ name, achievement_level }) =>
    GTMAchievementsModal({ name, achievement_level }),
  GTMEnergy: () => GTMEnergy(),
  GTMEnergyExchange: () => GTMEnergyExchange(),
  GTMGamesAddToWishlist: ({ name, item_sku }) => GTMGamesAddToWishlist({ name, item_sku }),
  GTMGamesAddToCart: ({ name, item_sku }) => GTMGamesAddToCart({ name, item_sku }),
  GTMGamesBrand: ({ name, item_sku }) => GTMGamesBrand({ name, item_sku }),
  GTMGamesShop: ({ name }) => GTMGamesShop({ name }),
  GTMGamesProduct: ({ name, item_sku }) => GTMGamesProduct({ name, item_sku }),
  GTMGamesReturn: ({ name }) => GTMGamesReturn({ name }),
  GTMGamesExit: ({ name }) => GTMGamesExit({ name }),
  GTMBeautyRoutineProducts: () => GTMBeautyRoutineProducts(),
  GTMBeautyRoutineContinue: () => GTMBeautyRoutineContinue(),
  GTMBeautyRoutineAddToWishlist: ({ item_sku }) => GTMBeautyRoutineAddToWishlist({ item_sku }),
  GTMBeautyRoutineAddToCart: ({ item_sku }) => GTMBeautyRoutineAddToCart({ item_sku }),
  GTMBeautyRoutineBrand: ({ item_sku }) => GTMBeautyRoutineBrand({ item_sku }),
  GTMBeautyRoutineShop: () => GTMBeautyRoutineShop(),
  GTMBeautyRoutineProduct: ({ item_sku }) => GTMBeautyRoutineProduct({ item_sku }),
  GTMBeautyRoutine: () => GTMBeautyRoutine(),
  GTMMoreBuyForSelf: ({ block_name }) => GTMMoreBuyForSelf({ block_name }),
  GTMMoreWishlist: ({ block_name }) => GTMMoreWishlist({ block_name }),
  GTMMoreBuyForElf: ({ block_name }) => GTMMoreBuyForElf({ block_name }),
  GTMChallengesBanner: () => GTMChallengesBanner(),
  GTMCustomizationBanner: () => GTMCustomizationBanner(),
  GTMGamesJumpToNextProduct: ({ item_sku }) => GTMGamesJumpToNextProduct({ item_sku }),
  GTMGamesJumpToPrevProduct: ({ item_sku }) => GTMGamesJumpToPrevProduct({ item_sku }),
  GTMGamesJumpToProduct: ({ item_sku }) => GTMGamesJumpToProduct({ item_sku }),
  GTMGamesAddToWishlistBeautyPad: ({ item_sku }) => GTMGamesAddToWishlistBeautyPad({ item_sku }),
  GTMGamesAddToCartBeautyPad: ({ item_sku }) => GTMGamesAddToCartBeautyPad({ item_sku }),
  GTMGamesClickProductBeautyPad: ({ item_sku }) => GTMGamesClickProductBeautyPad({ item_sku }),
}

export const GTMPalleteTutorial = () => {
  const currentStore = getCurrentStore()
  if (currentStore === 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'click_next_onboarding',
    },
  })
}

export const GTMHello = () => {
  const currentStore = getCurrentStore()
  if (currentStore === 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'click_next_onboarding_greeting',
    },
  })
}

export const GTMGoToShopAfterPrize = () => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'prizes_go_to_shopping',
    },
  })
}

export const GTMToShopAfterQuest = (name) => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'tasks_go_to_shopping',
      name,
    },
  })
}

export const GTMToProductAfterQuest = (name, item_sku) => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'tasks_click_product',
      name,
      item_sku,
    },
  })
}

export const GTMToProductAfterProcedure = (type, item_sku) => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'bathroom_procedure_click_product',
      type,
      item_sku,
    },
  })
}

export const GTMToProductAfterQuiz = (number, item_sku) => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'bathroom_quiz_click_product',
      number,
      item_sku,
    },
  })
}

export const GTMStart = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'click_start',
    },
  })
}

export const GTMSignUp = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'click_reg',
    },
  })
}

export const GTMStartElf = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'click_start_game',
    },
  })
}

export const GTMContinueName = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'click_next_screen_name',
    },
  })
}

export const GTMUnderstand = () => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'click_next_onboarding_quests',
    },
  })
}

export const GTMUnderstandFinish = () => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'click_next_onboarding_finish',
    },
  })
}

export const GTMQuests = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'main_click_tasks',
    },
  })
}

export const GTMGifts = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'main_click_gifts',
    },
  })
}

export const GTMBath = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'main_click_shower',
    },
  })
}

export const GTMFriends = () => {
  const currentStore = getCurrentStore()
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: currentStore === 'ru' ? 'main_click_friends' : 'main_click_profile',
    },
  })
}

export const GTMGames = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'main_click_joystick',
    },
  })
}

export const GTMCustomization = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'main_click_palette',
    },
  })
}

export const GTMPrizes = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'main_click_cup',
    },
  })
}

export const GTMRoadmap = () => {
  const currentStore = getCurrentStore()
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: currentStore === 'ru' ? 'main_click_roadmap' : 'main_click_flag',
    },
  })
}

export const GTMGame = (name) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'mini_games_to_game',
      name,
    },
  })
}

export const GTMShop = () => {
  const currentStore = getCurrentStore()
  if (currentStore === 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'main_click_shop',
    },
  })
}

export const GTMEndGame = (name, type) => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'mini_games_show_end_screen',
      type,
      name,
    },
  })
}

export const GTMMain = () => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'bathroom_click_to_main',
    },
  })
}

export const GTMQuiz = () => {
  const currentStore = getCurrentStore()
  if (currentStore === 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'main_click_quiz',
    },
  })
}

export const GTMProcedure = (type) => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'bathroom_click_to_procedure',
      type,
    },
  })
}

export const GTMQuizSuccess = (number) => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'bathroom_quiz_success',
      number,
    },
  })
}

export const GTMBuyBtn = (number) => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'bathroom_quiz_go_to_shopping',
      number,
    },
  })
}

export const GTMQuizBackToGame = (number) => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'bathroom_quiz_click_again',
      number,
    },
  })
}

export const GTMQuizCopyPromo = (number) => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'bathroom_copy_promocode',
      number,
    },
  })
}

export const GTMProcedureSuccess = (type) => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'bathroom_procedure_success',
      type,
    },
  })
}

export const GTMProcedureBuyBtn = (type) => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'bathroom_procedure_go_to_shopping',
      type,
    },
  })
}

export const GTMProcedureBackToGame = (type) => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'bathroom_procedure_click_again',
      type,
    },
  })
}

export const GTMQuestSuccess = () => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'tasks_click_subscribe',
    },
  })
}

export const GTMShare = () => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'friends_click_share_game',
    },
  })
}

export const GTMAddFriend = () => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'friends_click_add_id',
    },
  })
}

export const GTMFriendClick = () => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'friends_click_friend',
    },
  })
}

export const GTMFriendReaction = () => {
  const currentStore = getCurrentStore()
  if (currentStore !== 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'friends_click_emoji',
    },
  })
}

export const GTMShopItem = (name) => {
  const currentStore = getCurrentStore()
  if (currentStore === 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'shop_click_chapter',
      name,
    },
  })
}

export const GTMOnClickOnboardingPalette = () => {
  const currentStore = getCurrentStore()
  if (currentStore === 'ru') return

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory(),
      action_type: 'click_next_onboarding_palette',
    },
  })
}

export const GTMChallenges = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_achievements_challenges',
    },
  })
}

export const GTMChallengesTabs = ({ tab }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: `click_${tab}_tab`,
    },
  })
}

export const GTMBoxes = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_box_icon',
    },
  })
}

export const GTMBoxesBuy = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_buy_box',
    },
  })
}

export const GTMAchievements = ({ name }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_achievement',
      name,
    },
  })
}

export const GTMAchievementsModal = ({ name, achievement_level }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_continue_achievement_reward',
      name,
      achievement_level,
    },
  })
}

export const GTMEnergy = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_energy_icon',
    },
  })
}

export const GTMEnergyExchange = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_exchange_energy',
    },
  })
}

export const GTMGamesAddToWishlist = ({ name, item_sku }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'add_to_wishlist_after_minigame',
      name,
      item_sku,
    },
  })
}

export const GTMGamesAddToCart = ({ name, item_sku }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'add_to_cart_after_minigame',
      name,
      item_sku,
    },
  })
}

export const GTMGamesBrand = ({ name, item_sku }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_brand_after_minigame',
      name,
      item_sku,
    },
  })
}

export const GTMGamesShop = ({ name }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_shop_after_minigame',
      name,
    },
  })
}

export const GTMGamesProduct = ({ name, item_sku }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_product_after_minigame',
      name,
      item_sku,
    },
  })
}

export const GTMGamesReturn = ({ name }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_return_to_game',
      name,
    },
  })
}

export const GTMGamesExit = ({ name }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_exit_minigame',
      name,
    },
  })
}

export const GTMBeautyRoutineProducts = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_beauty_routine_products',
    },
  })
}

export const GTMBeautyRoutineContinue = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_continue_beauty_routine',
    },
  })
}

export const GTMBeautyRoutineAddToWishlist = ({ item_sku }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'add_to_wishlist_beauty_routine',
      item_sku,
    },
  })
}

export const GTMBeautyRoutineAddToCart = ({ item_sku }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'add_to_cart_beauty_routine',
      item_sku,
    },
  })
}

export const GTMBeautyRoutineBrand = ({ item_sku }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_brand_beauty_routine',
      item_sku,
    },
  })
}

export const GTMBeautyRoutineShop = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_shop_beauty_routine',
    },
  })
}

export const GTMBeautyRoutineProduct = ({ item_sku }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_product_beauty_routine',
      item_sku,
    },
  })
}

export const GTMBeautyRoutine = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_beauty_routine_icon',
    },
  })
}

export const GTMMoreBuyForSelf = ({ block_name }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_more_section_buy_for_self',
      block_name,
    },
  })
}

export const GTMMoreWishlist = ({ block_name }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_more_section_wishlist',
      block_name,
    },
  })
}

export const GTMMoreBuyForElf = ({ block_name }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_more_section_buy_for_elf',
      block_name,
    },
  })
}

export const GTMChallengesBanner = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_tasks_banner',
    },
  })
}

export const GTMCustomizationBanner = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_kiosk_banner',
    },
  })
}

export const GTMGamesJumpToNextProduct = ({ item_sku }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'jump_to_next_product',
      item_sku,
    },
  })
}

export const GTMGamesJumpToPrevProduct = ({ item_sku }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'jump_to_prev_product',
      item_sku,
    },
  })
}

export const GTMGamesJumpToProduct = ({ item_sku }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'jump_to_product',
      item_sku,
    },
  })
}

export const GTMGamesAddToWishlistBeautyPad = ({ item_sku }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'add_to_wishlist_beauty_pad',
      item_sku,
    },
  })
}

export const GTMGamesAddToCartBeautyPad = ({ item_sku }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'add_to_cart_beauty_pad',
      item_sku,
    },
  })
}

export const GTMGamesClickProductBeautyPad = ({ item_sku }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_category: getEventCategory({ isNewEvent: true }),
      action_type: 'click_product_beauty_pad',
      item_sku,
    },
  })
}
